export enum IspmTab {
    OVERVIEW = 'Overview',
    CUSTOMIZATION = 'Customization'
}
